import React, { ReactNode } from "react";

import { Dialog } from "@mui/material";
import { UserAction } from "../type";
import { MigrateEmailForm } from "./MigrateEmailForm";
import { ResendActivationForm } from "./ResendActivationForm";
import { SendNotificationForm } from "./SendNotificationForm";

import { UserAdminInfo } from "../../../../api/users";

/// A dialog component that renders different user action forms based on the action type
export const UserActionDialog: React.FC<{
  action: UserAction | null;
  user: UserAdminInfo;
  onClose: () => void;
  refreshUsers: () => void;
}> = ({ action, user, onClose, refreshUsers }) => {
  const { id: userId, email: userEmail, displayName: userName } = user;

  if (!action) return null;

  let dialogContent: ReactNode;
  switch (action) {
    case UserAction.MIGRATE_EMAIL:
      dialogContent = (
        <MigrateEmailForm
          userId={userId}
          userEmail={userEmail}
          onClose={onClose}
          onSuccess={refreshUsers}
        />
      );
      break;
    case UserAction.RESEND_ACTIVATION:
      dialogContent = (
        <ResendActivationForm
          userId={userId}
          userEmail={userEmail}
          onClose={onClose}
        />
      );
      break;
    case UserAction.SEND_NOTIFICATION:
      dialogContent = (
        <SendNotificationForm
          userId={userId}
          userName={userName}
          onClose={onClose}
        />
      );
      break;

  }

  return (
    <Dialog open={!!action} onClose={onClose} fullWidth maxWidth="sm">
      {dialogContent}
    </Dialog>
  );
};
